import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'list-workflows' as const;

const argumentZod = z.object({});

export const listWorkflowsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List AI workflows',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      "Lists all AI workflows configured for the current site. Returns each workflow's ID, name, active status, and template slug.",
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: false,
});

export type ListWorkflowsArgumentType = z.infer<typeof argumentZod>;
